<template>
  <!-- , width: fixedHeader ? `calc(100% - ${sidebarOpened ? 256 : 80}px)` : '100%'  -->
  <a-layout-header
    :class="[fixedHeader && 'ant-header-fixedHeader', sidebarOpened ? 'ant-header-side-opened' : 'ant-header-side-closed', ]"
    :style="{ padding: '0' }">
    <div class="head" :class="theme">
      <!-- <div style="float: left;margin-left: 20px">
        <label v-if="$route.path==='/pad/index'">
          首页
        </label>
        <template v-else>
          <a-button  type="primary" size="small" icon="left" @click="goback">
            返回
          </a-button>
          <a-button  type="primary" size="small" @click="reloadWindow">
            刷新页面
          </a-button>
        </template>
      </div> -->
      <!-- <span v-if="$route.path!=='/pad/index'">{{projectName}}</span> -->
      <ul class="menu">
        <li>
          <icon-back color="#41a7e6" @back="goback"></icon-back>
        </li>
        <li>
          <refresh color="#41a7e6" @refreshClick="reloadWindow"></refresh>
        </li>
        <li @click="menuClick(0)" style="margin-left: 100px">
          <router-link to="/pad/index" :class="{'router-link-active':curMenu === 0}">数据采集</router-link>
        </li>
        <li @click="menuClick(1)">
          <router-link to="/pad/proposalConfig" :class="{'router-link-active':curMenu === 1}">方案配置</router-link>
        </li>
      </ul>
      <user-menu :theme="theme"/>
    </div>
  </a-layout-header>
</template>

<script>
  import UserMenu from '@/components/apppad/tools/UserMenu'
  import Logo from '@/components/tools/Logo'
  import { mapGetters } from 'vuex'
  import { getAction } from '@/api/manage'

  import { mixin } from '@/utils/mixin'
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
  import Vue from 'vue'
  import IconBack from '@comp/Icon/IconBack'
  import Refresh from '@comp/Icon/Refresh'

  export default {
    name: 'GlobalHeader',
    components: {
      UserMenu,
      Logo,
      IconBack,
      Refresh
    },
    mixins: [mixin],
    props: {
      mode: {
        type: String,
        // sidemenu, topmenu
        default: 'sidemenu'
      },
      menus: {
        type: Array,
        required: true
      },
      theme: {
        type: String,
        required: false,
        default: 'light'
      },
      collapsed: {
        type: Boolean,
        required: false,
        default: false
      },
      device: {
        type: String,
        required: false,
        default: 'desktop'
      },
      projectName: {
        type: String,
        required: false,
        default: ''
      }
    },
    data() {
      return {
        company:window._CONFIG.company,
        adminRole:window._CONFIG.adminRole,
        platformName:window._CONFIG['platformName'],
        headerBarFixed: false,
        //update-begin--author:sunjianlei---date:20190508------for: 顶部导航栏过长时显示更多按钮-----
        topMenuStyle: {
          headerIndexLeft: {},
          topNavHeader: {},
          headerIndexRight: {},
          topSmenuStyle: {}
        },
        chatStatus: '',
        curMenu:sessionStorage.getItem('curMenu') === null ? 0: Number(sessionStorage.getItem('curMenu'))
        // projectId:sessionStorage.getItem(CACHE_PROJECT_ID) ||'',
        // projectName:sessionStorage.getItem(CACHE_PROJECT_NAME) || '',
      }
    },
    computed:{
    },
    watch: {
      /** 监听设备变化 */
      device() {
        if (this.mode === 'topmenu') {
          this.buildTopMenuStyle()
        }
      },
      /** 监听导航栏模式变化 */
      mode(newVal) {
        if (newVal === 'topmenu') {
          this.buildTopMenuStyle()
        }
      }
    },
    //update-end--author:sunjianlei---date:20190508------for: 顶部导航栏过长时显示更多按钮-----
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
      //update-begin--author:sunjianlei---date:20190508------for: 顶部导航栏过长时显示更多按钮-----
      if (this.mode === 'topmenu') {
        this.buildTopMenuStyle()
      }
      //update-end--author:sunjianlei---date:20190508------for: 顶部导航栏过长时显示更多按钮-----
    },
    methods: {
      ...mapGetters(["userInfo"]),
      includes(arr1,arr2){
        return arr1.filter(item=>{
          return arr2.includes(item)
        })
      },
      reloadWindow(){
        window.location.reload()
      },
      handleScroll() {
        if (this.autoHideHeader) {
          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
          if (scrollTop > 100) {
            this.headerBarFixed = true
          } else {
            this.headerBarFixed = false
          }
        } else {
          this.headerBarFixed = false
        }
      },
      toggle() {
        this.$emit('toggle')
      },
      goback(){
        this.$router.back()
      },
      menuClick(cur){
        sessionStorage.setItem('curMenu',`${cur}`)
        this.curMenu = cur;
      }
    }
  }
</script>

<style lang="less" scoped>

  @height: 59px;

  .layout {

    .top-nav-header-index {

      .header-index-wide {
        margin-left: 10px;

        .ant-menu.ant-menu-horizontal {
          height: @height;
          line-height: @height;
        }
      }
      .trigger {
        line-height: 64px;
        &:hover {
          background: rgba(0, 0, 0, 0.05);
        }
      }
    }

    .head {
      color: white;
      height: @height;
      background-color: @primary-color;
      transition: background 300ms;
      padding: 0 20px;
      display: flex;
      justify-content: space-between;
      .menu{
        margin: 0;
        padding: 0;
        list-style: none;
        display: flex;
        justify-content: space-between;
        li{
          margin-right: 20px;
        }
        a{
          color: #41a7e6;
        }
        .router-link-active {
          color: white;
        }
        .back {
          cursor: pointer;
        }
      }

      /* dark 样式 */
      &.dark {
        color: #000000;
        box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
        background-color: white !important;
      }
    }

    .header, .top-nav-header-index {
      &.dark .trigger:hover {
        background: rgba(0, 0, 0, 0.05);
      }
    }
  }

  .ant-layout-header {
    height: @height;
    line-height: @height;
  }
  .logo {
    height: 32px;
    width: 42px;
    margin-top: 15px;
    vertical-align: top;
    margin-right: 16px;
    border-style: none;
  }

</style>
